// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__GMw3Q","wait":"styles_wait__1imey"};